import { ICulture, supportedCultures as supportedCoreCultures } from '@mds/angular-core';

export const supportedCultures: ICulture[] = [...supportedCoreCultures.filter((c) => ['de', 'en', 'fr'].includes(c.isoCode))];
